<script setup lang="ts">
import confused from '@/assets/images/confused.png';
import { ArrowRightIcon } from '@heroicons/vue/20/solid';

const contactSupport = () => {
    window.open('mailto:ishveer@emailmeter.com', '_blank');
};
</script>

<template>
    <div class="flex flex-col justify-center items-center h-full font-semibold">
        <img :src="confused" alt="confused" />
        <p class="text-3xl text-gray-900 leading-9 mb-2">Whoa! How did you end up here?</p>
        <p class="text-base text-gray-600 leading-6 font-normal">We couldn’t find the page you are looking for</p>
        <div class="flex justify-between gap-4 mt-8">
            <ButtonG size="lg" to="/" text="Go back to the homepage" />
            <ButtonG size="lg" text="Contact support" hierarcy="outline" @click="contactSupport" :icon-trailing="ArrowRightIcon" />
        </div>
    </div>
</template>
